import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const SITE = process.env.REACT_APP_BACKEND_URL;
const NAME = "LUX AETERNA";
const DEFAULT_DESC = "LUX AETERNA — Spazio Olistico. Registri Akashici, consulti spirituali, trattamenti energetici, Lux Academy e Tema Natale interattivo. Dove l'impossibile diventa possibilità.";
const DEFAULT_IMG = `${SITE}/og-image.jpg`;

export const ORG_LD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: NAME,
  alternateName: "Lux Aeterna Spazio Olistico",
  url: SITE,
  logo: DEFAULT_IMG,
  email: "info.luxaeterna.spazioolistico@gmail.com",
  founder: { "@type": "Person", name: "Davide Bellafiore", jobTitle: "Operatore olistico, spiritual coach, insegnante dei Registri Akashici" },
  areaServed: "IT",
  slogan: "Dove l'impossibile diventa possibilità.",
};

// Aggiorna in-place i tag statici di index.html (nessun duplicato, default validi anche senza JS).
function upsert(selector, attrs, create) {
  let el = document.head.querySelector(selector);
  if (!el) { el = create(); document.head.appendChild(el); }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  return el;
}
const meta = (key, isProp, content) =>
  upsert(`meta[${isProp ? "property" : "name"}="${key}"]`, { [isProp ? "property" : "name"]: key, content }, () => document.createElement("meta"));

export default function Seo({ title, description = DEFAULT_DESC, image = DEFAULT_IMG, type = "website", jsonLd, noindex = false }) {
  const { pathname } = useLocation();
  const url = `${SITE}${pathname}`;
  const full = title ? `${title} — ${NAME}` : `${NAME} — Spazio Olistico · Registri Akashici e Lux Academy`;
  const desc = (description || DEFAULT_DESC).replace(/\s+/g, " ").trim().slice(0, 160);
  const ld = JSON.stringify(Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : []);

  useEffect(() => {
    document.documentElement.lang = "it";
    document.title = full;
    meta("description", false, desc);
    meta("og:site_name", true, NAME);
    meta("og:locale", true, "it_IT");
    meta("og:type", true, type);
    meta("og:title", true, full);
    meta("og:description", true, desc);
    meta("og:url", true, url);
    meta("og:image", true, image || DEFAULT_IMG);
    meta("twitter:card", false, "summary_large_image");
    meta("twitter:title", false, full);
    meta("twitter:description", false, desc);
    meta("twitter:image", false, image || DEFAULT_IMG);
    upsert('link[rel="canonical"]', { rel: "canonical", href: url }, () => document.createElement("link"));
    const robots = document.head.querySelector('meta[name="robots"]');
    if (noindex) meta("robots", false, "noindex,nofollow");
    else if (robots) robots.remove();
    let script = document.getElementById("seo-jsonld");
    if (!script) { script = document.createElement("script"); script.id = "seo-jsonld"; script.type = "application/ld+json"; document.head.appendChild(script); }
    script.textContent = ld;
  }, [full, desc, url, image, type, noindex, ld]);

  return null;
}
